import { AssetPresentationRatioEnum, KuxMediaAssetType, KuxRailImageArg } from '../../interfaces';

import { calculateSizePerDevice, getResizerUrl, imageScale, KuxImage } from './image';

export interface KuxImageRail {
  height: number;
  width: number;
  originImageUrl?: string;
  imageUrl?: string;
}

export const findByRatioV2 = (asset: KuxMediaAssetType, ratio: AssetPresentationRatioEnum): KuxImage | undefined =>
  asset.images[ratio];
/**
 *
 * @param options: KuxRailImageArg
 * @param ratio: AssetPresentationRatioEnum
 */

/**
 * Find ratio
 *
 * @param asset
 * @param options
 */
export const getRatioByAssetV2 = (asset: KuxMediaAssetType, options: KuxRailImageArg): AssetPresentationRatioEnum => {
  if (!options.assetImageSource) {
    return options.assetPresentationRatio;
  }

  const metas = asset.metas;

  const defaultRatio = metas['default_ratio'] as unknown as AssetPresentationRatioEnum;
  return defaultRatio || options.assetPresentationRatio;
};

/**
 * Find image for rail item
 * @param asset
 * @param options
 */
export const findRailImageV2 = (asset: KuxMediaAssetType, options: KuxRailImageArg): KuxImageRail => {
  const ratio = getRatioByAssetV2(asset, options);

  const { width, height } = calculateSizePerDevice(options, ratio);
  const originImage = findByRatioV2(asset, ratio);

  if (originImage) {
    return {
      height,
      width,
      originImageUrl: originImage.url,
      imageUrl: getResizerUrl(originImage.url, height * imageScale, width * imageScale),
    };
  }
  return {
    height,
    width,
  };
};
